export default __webpack_public_path__ + "static/media/Nozzle, Red.1a3c93fc.png";